// extracted by mini-css-extract-plugin
export default {"PostCreate":"qp_a bhy_qt bhy_a bhy_w bhy_ea"};